<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: ['Cantidad'],
                    datasets: [
                        {
                            label: 'Jornadas de Adopción',
                            backgroundColor: hexToRgba('#00ff41', 70),
                            fill: true,
                            data: [5]
                        },
                        {
                            label: 'Perros rescatados',
                            backgroundColor: hexToRgba('#ffec3c', 70),
                            fill: true,
                            data: [32]
                        },
                        {
                            label: 'Perros desde 2017',
                            backgroundColor: hexToRgba('#ff0326', 70),
                            fill: true,
                            data: [111]
                        },
                        {
                            label: 'Esterilizaciones',
                            backgroundColor: hexToRgba('#09c0ff', 70),
                            fill: true,
                            data: [133]
                        },
                        {
                            label: 'Atención de Veterinarios por atropellos con fractura',
                            backgroundColor: hexToRgba('#b251ff', 70),
                            fill: true,
                            data: [80]
                        }

                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                            ticks: {
                                precision: 0,
                                beginAtZero: true,
                                suggestedMax: 50
                            }
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
